var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.663 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    className: "cls-1",
    d: "M12.262,14.474A7.751,7.751,0,1,0,8,15.75h8.913",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_303",
    "data-name": "Ellipse 303",
    className: "cls-1",
    cx: 1.938,
    cy: 1.938,
    rx: 1.938,
    ry: 1.938,
    transform: "translate(5.813 1.938)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_304",
    "data-name": "Ellipse 304",
    className: "cls-1",
    cx: 1.938,
    cy: 1.938,
    rx: 1.938,
    ry: 1.938,
    transform: "translate(5.813 9.688)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_305",
    "data-name": "Ellipse 305",
    className: "cls-1",
    cx: 1.938,
    cy: 1.938,
    rx: 1.938,
    ry: 1.938,
    transform: "translate(1.938 5.813)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_306",
    "data-name": "Ellipse 306",
    className: "cls-1",
    cx: 1.938,
    cy: 1.938,
    rx: 1.938,
    ry: 1.938,
    transform: "translate(9.688 5.813)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_363",
    "data-name": "Line 363",
    className: "cls-1",
    x2: 0.775,
    transform: "translate(7.363 7.75)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.8669a70385f534831fa3384eeccfe2da.svg";
export { ForwardRef as ReactComponent };